<template>
    <div class="image__box">
        <img
            v-if="isImage"
            class="image__cover"
            :src="url"
            :alt="alt"
            @error="imageNotFound"
        />
        <div v-else class="image__box image__box__overlay"></div>
    </div>
</template>

<script>
export default {
    name: 'LazyImage',
    props: {
        url: { type: String, default: '' },
        alt: { type: String, default: '' }
    },
    data() {
        return {
            isImage: true
        }
    },
    methods: {
        imageNotFound() {
            this.isImage = false
        }
    }
}
</script>

<style lang="scss" scoped>
.image__box {
    width: 100%;
    height: 100%;
}
.image__box__overlay {
    background-color: grey;
}

.image__cover {
    object-fit: contain;
    width: 100%;
    height: 100%;
}
</style>
